module.exports = __webpack_public_path__ + "static/media/undraw_portfolio_amber.201e1929.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/undraw_portfolio_amber.svg
// module id = 1097
// module chunks = 2